/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        17/02/2020      2560: 400 Bad Request Issue with gemtriageapi-qa3 POST GemTriage/UpdateTriageLogSymptoms
*********************************************************************************/
import { withProps } from "@mna/react";
import PageTitle from "features/PageTitle";
import LoadingScreen from "features/LoadingScreen";
import { Trans } from "react-i18next";
import { checkAndGetLocalStorageValue } from "../../../features/utils";
import i18next from "../../../../src/i18n";

const emergencytitle = (
  <Trans i18nKey="findcareoption.Emergency">Are you experiencing a life-threatening emergency?</Trans>
);

const Page = ({
  state,
  actions,
  history,
  nextStepName,
  hasCurrentLocation,
}) => {
  if (state.isLoading_Emergency) { setState({ isLoading_Emergency: false }); }
  return (
    <LoadingScreen isLoading={state.isLoading_Emergency}>
      {state.screenLoaded ? (
        <section className="standby-content standby-content-middle top-half">
          <article className="standby-article">
            <div role="group">
              <PageTitle titleText={emergencytitle} align="center" />
              <h2 className="standby-center mt-0 pb-2 standby-color fontWeight"><Trans i18nKey="findcareoption.EmergencyTitleHint">(Ex: chest pain, choking, stroke, heavy bleeding, severe injury)</Trans></h2>
              <div className="emergency-options">
                <div>
                  <button
                    type="button"
                    className="button emergency-option emergency-option-true"
                    aria-label={i18next.t("findcareoption.Emergency") + " " + i18next.t("findcareoption.Yes") }
                    onClick={() => {
                      state.triageRequest.isFacilitySearch = false
                      state.triageRequest.emergency = true;
                      localStorage.setItem("careoption", "");
                      state.triageRequest.gender = "";
                      state.triageRequest.data = undefined;
                      actions.setTriageBio({ sessionId: new Date().getTime() });
                      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));

                      actions.setTriageSelectedCareOption({
                        name: "Emergency Room",
                        score: 0,
                      });
                      actions.createTriageEmergencySession({
                        hasCurrentLocation,
                        nextStepName,
                        history,
                      });
                    }}
                  >
                    <div className="icon icon-size-3">
                      <svg
                        viewBox="0 0 18 18"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        strokeLinejoin="round"
                        strokeMiterlimit="1.414"
                        alt="Emergency YES"
                      >
                        <path
                          d="M16.068 4.89a8.14 8.14 0 0 0-2.974-2.974A8 8 0 0 0 8.992.82 8 8 0 0 0 4.89 1.916 8.13 8.13 0 0 0 1.917 4.89 7.99 7.99 0 0 0 .82 8.992a7.994 7.994 0 0 0 1.096 4.101 8.14 8.14 0 0 0 2.974 2.974 7.998 7.998 0 0 0 4.102 1.096 8 8 0 0 0 4.102-1.095 8.14 8.14 0 0 0 2.974-2.974 8 8 0 0 0 1.095-4.102 7.997 7.997 0 0 0-1.095-4.102zm-5.714 9.201a.35.35 0 0 1-.096.25.314.314 0 0 1-.234.101H7.981a.366.366 0 0 1-.351-.351v-2.027a.366.366 0 0 1 .351-.351h2.043a.31.31 0 0 1 .234.101.346.346 0 0 1 .096.25v2.027zm-.021-3.661a.269.269 0 0 1-.112.186.397.397 0 0 1-.249.076H8.003a.419.419 0 0 1-.256-.08.23.23 0 0 1-.106-.187L7.46 3.821a.211.211 0 0 1 .107-.192.398.398 0 0 1 .255-.085h2.341a.401.401 0 0 1 .256.085.212.212 0 0 1 .106.192l-.192 6.609z"
                          fillRule="nonzero"
                        />
                      </svg>
                    </div>
                    <div>
                      <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                    </div>
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    className="button emergency-option emergency-option-false"
                    aria-label={i18next.t("findcareoption.Emergency") + " " + i18next.t("findcareoption.No") }
                    onClick={() => {
                      state.triageRequest.gender = "";
                      state.triageRequest.data = undefined
                      state.triageRequest.isFacilitySearch = false
                      state.triageRequest.dateofbirth = undefined;                      
                      localStorage.setItem("careoption", "");
                      state.triageRequest.emergency = false;
                      if (state.isTravelAid2 == true) {
                        state.triageRequest.activeMenu = "location"
                        var gender=null;
                        var isEmergency = state.triageRequest.emergency;
                        actions.setTriageBio({ sessionId: new Date().getTime() });
                        sessionStorage.setItem("isEmergency",isEmergency);
                        sessionStorage.removeItem("locationScreen");
                        state.triageRequest.emergency = false;
                        actions.createTriageSession({
                          hasCurrentLocation,
                          nextStepName,
                          history
                        })
                        history.push(
                          `/find-care-options/${"location"}`
                        );
                      } else {
                        state.triageRequest.activeMenu = "start";
                        history.push(
                          `/find-care-options/${"start"
                          }`
                        );
                      }
                      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                    }}
                  >
                    <div className="icon icon-size-2">
                      <svg
                        data-name="cancel"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        alt="Emergency NO"
                      >
                        <path
                          data-name="x"
                          d="M14.579 10l4.95-4.95A1.557 1.557 0 0 0 20 3.906a1.56 1.56 0 0 0-.471-1.145l-2.29-2.29a1.626 1.626 0 0 0-2.29 0L10 5.421 5.051.471A1.558 1.558 0 0 0 3.906 0a1.559 1.559 0 0 0-1.145.471l-2.29 2.29A1.559 1.559 0 0 0 0 3.906a1.558 1.558 0 0 0 .471 1.145L5.421 10l-4.95 4.95a1.626 1.626 0 0 0 0 2.289l2.29 2.29A1.558 1.558 0 0 0 3.906 20a1.559 1.559 0 0 0 1.145-.471L10 14.579l4.95 4.95a1.626 1.626 0 0 0 2.29 0l2.289-2.29a1.626 1.626 0 0 0 0-2.289z"
                        />
                      </svg>
                    </div>
                    <div>
                      <Trans i18nKey="findcareoption.No">No</Trans>
                    </div>
                  </button>
                </div>
              </div>
              { state.isCallCenter && <div className="emergQuestion-facilitySearch">
                <strong>
                  <a href="#" onClick={()=>{
                    state.triageRequest.isFacilitySearch= true
                    state.triageRequest.data = undefined
                    state.triageRequest.gender = "";
                    actions.setTriageBio({ sessionId: new Date().getTime() });
                    actions.createTriageSession({
                      hasCurrentLocation,
                      nextStepName,
                      history
                    })
                    history.push(
                      `/find-care-options/${"location"}`
                    );
                  }}><Trans i18nKey="facilitySearch">Facility Search</Trans></a>
                </strong>
              </div>}
            </div>
          </article>
        </section>
      ) : null}
    </LoadingScreen>
  )
};

export default withProps((props) => {
  const { state } = props;
  const { triageRequest } = state;

  //485:
  console.log(triageRequest.emergency);
  localStorage.setItem("IsEmergencySelected", triageRequest.emergency);

  const hasCurrentLocation =
    triageRequest.location.lat && triageRequest.location.lng;

  return {
    ...props,
    hasCurrentLocation,
  };
})(Page);
